<template>
	<main id="liste" v-cloak>
		<HeaderTab :title="pageTitle" :icon="['fal', 'horse']" />
		
		<div v-if="booted" id="content">
			<div class="container-fluid">
				<div class="row align-items-center">
					<div class="col-12">
						<p>{{ $t(searchTextKey) }}</p>
					</div>
				</div>
				<div class="d-md-flex align-items-center">
					<div class="flex-grow-1 mb-1">
						<div class="input-group">
							<div v-if="all_types_search.length > 1" class="input-group-prepend">
								<e-select
								track-by="code"
								label="label"
								:options="all_types_search"
								:allow-empty="false"
								:show-labels="false"
								v-model="type_search"
								/>
							</div>
							<input ref="searchInput" type="text" class="form-control" :value="search_value" @input="search_value = $event.target.value.toUpperCase()" @keydown.enter.prevent="search" required :placeholder="$t('horse.placeholder_'+type_search.code)" style="text-transform: uppercase;">
						</div>
					</div>
					<div class="horse-ajout-buttons mb-1 flex-shrink-0">
						<router-link :to="{ name: 'horseCreation', params: {...$route.params, value: search_value}, query: {...$route.query, horse_nom: search_value} }" class="btn btn-sm btn-outline-primary text-nowrap">{{ $t('horse.manual_add_fiche') }} <font-awesome-icon :icon="['fal', 'plus']" /></router-link>
						<b-button class="text-nowrap btn-sm" variant="primary" @click="search">{{ $t('global.rechercher') }} <font-awesome-icon v-if="searching" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'search']" /></b-button>
					</div>
				</div>
				<div class="row">
					<div class="col-12 d-none d-md-flex justify-content-center">
						<template v-for="(filter, index) in filters_saved">
							<b-button v-if="is_not_empty(filter)" @click="deleteFilter(index)" :key="index" variant="outline-secondary" rounded pill size="sm" class="mt-1 mr-2 md-mb-3 mb-1 d-md-flex d-inline-block text-nowrap flex-shrink-0 align-items-center btn-xs">
								{{ $t('horse.filter.'+index) }} : 
								<template v-if="index == 'race'">
									{{ race_formatted }}
								</template>
								<template v-else-if="index == 'sexe'">
									{{ filter.sexe_label }}
								</template>
								<template v-else-if="index == 'alive'">
									{{ $t('global.oui') }}
								</template>
								<template v-else>
									{{ filter }}
								</template>
								<font-awesome-icon class="ml-2" :icon="['fal', 'times']" />
							</b-button>
						</template>
					</div>
					
					<div v-if="code_erreur !== ''" class="col-12 text-center mt-5">
						<b-alert variant="warning" class="d-lg-inline-block mr-2" show>{{ error_message_trad }}<br><br>
							<router-link :to="{ name: 'horseCreation', params: $route.params, query: {...$route.query, horse_nom: search_value} }" class="btn btn-primary">{{ $t('horse.manual_add_fiche') }} <font-awesome-icon :icon="['fal', 'plus']" /></router-link>
						</b-alert>
					</div>
					<LoadingSpinner v-if="processing" class="col-12"/>
					<template v-else-if="type_search && type_search.code == 'ifce'">
						<div v-if="hasTooManyResults" class="col-12 mt-2">
							<b-alert variant="warning" show class="d-flex align-items-center justify-content-between mb-2">
								<span>{{ $t('horse.too_many_results') }}</span>
								<b-button variant="warning" size="sm" class="ml-2 text-nowrap" @click="openFilters">{{ $t('horse.add_filters') }} <font-awesome-icon :icon="['fal', 'filter']" class="ml-1" /></b-button>
							</b-alert>
						</div>
						<div v-if="horses.length > 0" class="col-12 mt-2">
							<div v-for="horse in horses" :key="horse.references.idPub" class="result_horse" @click="openTiersModal(horse)">
								<div class="row align-items-center">
									<div class="col-12 col-md">
										<h5 class="mb-0">{{ horse.nom }} <small>({{ horse.sire }}{{ horse.key }})</small></h5>
										{{ $t('horse.par') }} {{ horse.genealogy.sireName }} {{ $t('horse.et') }} {{ horse.genealogy.damName }}<br>
										{{ horse.codeRace }}, {{ horse.codeSexe }}, {{ horse.codeRobe }}, {{ horse.yearNaissance }}<br>
									
									</div>
									<div class="col-12 col-md-auto mt-2 mt-md-0">
										<b-button variant="secondary" block>{{ $t('global.ajouter') }}</b-button>
									</div>
								</div>
							</div>
						</div>
						<div v-if="show_buttons" class="col-12 row mt-3">
							<div class="col-12 text-center">
								<b>{{ $t('horse.dont_find') }}</b>
							</div>
							<div class="col-12 text-center">
								<div class="d-inline-flex justify-content-center">
									<template v-if="code_erreur === 'TMR' || hasTooManyResults">
										<b-button variant="primary" @click="openFilters">{{ $t('horse.try_add_filters') }} <font-awesome-icon :icon="['fal', 'plus-circle']" class="ml-2" /></b-button>
										<span class="mx-2 mt-2">{{ $t('global.ou') }}</span>
									</template>
								<router-link :to="{ name: 'horseCreation', params: $route.params, query: $route.query }" class="btn btn-primary">{{ $t('horse.manual_add_fiche') }} <font-awesome-icon :icon="['fal', 'plus']" /></router-link>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		
		<b-modal ref="filters" hide-footer>
			<template v-slot:modal-title>
				{{ $t("horse.add_filters") }}
			</template>
			<div v-if="type_search && type_search.code == 'ifce'" class="row">
				<div class="col-12 mt-1">
					<label for="date_min">{{ $t('horse.filter.date_min') }}</label>
					<input type="number" name="date_min" class="form-control" v-model="filters_ifce.date_min" :placeholder="getTrad('horse.filter.date_min')" />
				</div>
				<div class="col-12 mt-1">
					<label for="date_max">{{ $t('horse.filter.date_max') }}</label>
					<input type="number" name="date_max" class="form-control" v-model="filters_ifce.date_max" :placeholder="getTrad('horse.filter.date_max')"/>	
				</div>
				<div class="col-12 mt-1">
					<label for="sexe_code">{{ $t('horse.filter.sexe') }}</label>
					<e-select
					id="sexe_code"
					v-model="filters_ifce.sexe"
					track-by="sexe_code"
					label="sexe_label"
					:placeholder="$t('horse.filter.sexe')"
					:options="horse_sexes"
					:searchable="true"
					:allow-empty="false"
					:show-labels="false"
					/>
				</div>
				<div class="col-12 mt-1">
					<label for="race_code">{{ $t('horse.filter.race') }}</label>
					<e-select
					id="race_code"
					v-model="filters_ifce.race"
					track-by="race_code"
					label="race_label"
					:placeholder="$t('horse.filter.race')"
					:options="horse_races"
					:searchable="true"
					:allow-empty="false"
					:show-labels="false"
					:multiple="true"
					/>
				</div>
				<div class="col-12 mt-1">
					<label for="mother_name">{{ $t('horse.filter.mother_name') }}</label>
					<input type="string" name="mother_name" class="form-control" v-model="filters_ifce.mother_name" :placeholder="getTrad('horse.filter.mother_name')"/>
				</div>
				<div class="col-12 mt-1">
					<label for="father_name">{{ $t('horse.filter.father_name') }}</label>
					<input type="string" name="father_name" class="form-control" v-model="filters_ifce.father_name" :placeholder="getTrad('horse.filter.father_name')"/>
				</div>
				<div class="col-12 mt-1">
					<b-form-checkbox class="mr-2" v-model="filters_ifce.alive">{{ $t('horse.filter.alive') }}</b-form-checkbox>
				</div>
				<div class="col-12 mt-1 text-center">
					<b-button variant="primary" @click="saveFilters"><font-awesome-icon :icon="['fal', 'save']" class="ml-2" /> {{ $t('global.sauvegarder_filtrer') }}</b-button>
				</div>
			</div>
		</b-modal>
		
		<b-modal ref="tiers" hide-footer>
			<template v-slot:modal-title>
				{{ $t("horse.choose_proprietaire") }}
			</template>
			<div class="row">
				<div class="col-12">
					<e-select
					id="tiers"
					track-by="tiers_id"
					label="tiers_rs"
					:options="all_tiers"
					:searchable="true"
					:show-labels="false"
					:placeholder="$t('monte.selectionner_tiers')"
					v-model="tiers_selected"
					>
					<template slot="option" slot-scope="{ option }">{{ option.tiers_rs }}</template>
					<template slot="singleLabel" slot-scope="{ option }">{{ option.tiers_rs }}</template>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>
			<div class="col-12 mt-1 text-center">
				<b-button variant="primary" @click="addHorseSire">{{ $t('action.ajouter') }} <font-awesome-icon :icon="['fal', 'plus']" class="ml-2" /></b-button>
			</div>
		</div>
	</b-modal>
</main>
</template>

<script type="text/javascript">
import Horse from "@/mixins/Horse.js"
import UserMixin from "@/mixins/User.js"
import _deepClone from 'lodash/cloneDeep'
import _isEmpty from 'lodash/isEmpty'

export default {
	name: 'AddHorse',
	mixins: [Horse, UserMixin],
	props: ['from'],
	data () {
		return {
			search_value: '',
			all_types_search: [],
			type_search: null,
			code_erreur: '',
			booted: false,
			searching: false,
			processing: false,
			horses: [],
			filters_ifce: {
				date_min: null,
				date_max: null,
				mother_name: null,
				father_name: null,
				race: [],
				sexe: null,
				alive: true
			},
			filters_saved: {},
			horse_sexes: [],
			horse_races: [],
			horse_robes: [],
			licence_horses: [],
			show_licence_horses: false,
			licence_horses_load: false,
			show_buttons: false,
			raw_result_count: 0,
			all_tiers: [],
			tiers_selected: null,
			horse_selected: null
		}
	},
	
	mounted() {
		this.init_component()
	},
	
	methods: {
		async init_component() {
			this.all_types_search.push({
				code: 'ifce',
				label: 'IFCE'
			})
			this.type_search = this.all_types_search[0]
			
			this.horse_sexes = await this.getSexes()
			this.horse_races = await this.getRaces()
			this.horse_sexes.push({
				sexe_code: 'MH',
				sexe_label: this.getTrad('horse.male_hongre')
			})
			this.horse_robes = await this.getRobes()
			
			const config_race = this.getConfigHorseRaces()
			if(config_race.length > 0) {
				this.filters_ifce.race = this.horse_races.filter(race => config_race.includes(race.race_code))
			}
			const config_sexe = this.getConfigHorseSexes()
			if(config_sexe.length > 0) {
				this.filters_ifce.sexe = this.horse_sexes.find(sex => sex.sexe_code == config_sexe[0])
			}
			else if(this.$route.query.from === 'mare' || this.$route.query.from === 'contract') {
				this.filters_ifce.sexe = this.horse_sexes.find(sex => sex.sexe_code === 'F')
			}
			
			const date = new Date()
			this.filters_ifce.date_min = date.getFullYear() - 25
			this.filters_ifce.date_max = date.getFullYear() - 2
			
			this.filters_saved = _deepClone(this.filters_ifce)
			
			this.booted = true
			
			this.$nextTick(() => {
				if(this.$refs.searchInput) this.$refs.searchInput.focus()
			})
			
			this.all_tiers = this.getConfig('all_tiers')
		},
		
		openFilters() {
			this.$refs.filters.show()
		},
		
		search() {
			this.show_buttons = false
			this.searching = true
			this.horses = []
			this.raw_result_count = 0
			const input = this.clean_input(this.search_value)
			this['search_'+this.type_search.code](input)
		},
		
		async search_ifce(input) {
			// On commence par tester les regex d'erreurs possibles
			this.code_erreur = this.checkPotentialError(input)
			if(this.code_erreur == '') {
				let horse_id = null
				let exists = false
				if(this.regex_sire.test(input)) {
					const data = await this.addHorse(input, 'sire')
					horse_id = data.horse_id
					exists = !data.new
				}
				else if(this.regex_microship.test(input)) {
					const data = await this.addHorse(input, 'microship')
					horse_id = data.horse_id
					exists = !data.new
				}
				else if(this.regex_ueln.test(input)) {
					const data = await this.addHorse(input, 'ueln')
					horse_id = data.horse_id
					exists = !data.new
				}
				else if(this.regex_name_like.test(input)) {
					let filters = _deepClone(this.filters_saved)
					if(!_isEmpty(filters)) {
						if(filters.race && (filters.race.length > 1 || filters.race.length == 0)) {
							filters.race = null
						}
						else if(filters.race && filters.race.length == 1) {
							filters.race = filters.race[0]
						}
						
						if(filters.sexe && filters.sexe.sexe_code == 'MH') {
							filters.sexe = null
						}
					}
					
					const data = await this.fetchHorseByNameIfce(input, filters)
					if(data.code == 0) {
						let horses = data.result
						this.raw_result_count = horses.length
						if(!_isEmpty(this.filters_saved)) {
							if(this.filters_saved.alive) {
								horses = horses.filter(horse => !horse.dateMort)
							}
							
							if(this.filters_saved.race && this.filters_saved.race.length > 1) {
								const races_code = this.filters_saved.race.map(race => race.race_code)
								horses = horses.filter(horse => races_code.includes(horse.codeRace))
							}
							
							if(this.filters_saved.sexe && this.filters_saved.sexe.sexe_code == 'MH') {
								horses = horses.filter(horse => horse.codeSexe == 'M' || horse.codeSexe == 'H')
							}
						}
						this.horses = horses.map(horse => {
							let year = ''
							if(horse.dateNaissance) {
								const naissance = new Date(horse.dateNaissance)
								year = naissance.getFullYear()
							}
							let race = this.horse_races.find(race => race.race_code == horse.codeRace)
							race = race ? race.race_label : horse.codeRace
							
							let sexe = this.horse_sexes.find(sexe => sexe.sexe_code == horse.codeSexe)
							sexe = sexe ? sexe.sexe_label : horse.codeSexe
							
							let robe = this.horse_robes.find(robe => robe.robe_code == horse.codeRobe)
							robe = robe ? robe.robe_label : horse.codeRobe
							
							return {...horse, yearNaissance: year, codeRace: race, codeSexe: sexe, codeRobe: robe}
						})
						this.show_buttons = true
					}
					else {
						this.code_erreur = data.code
					}
				}
				if(horse_id) {
					this.next(horse_id)
				}
			}
			this.searching = false
		},
		
		async openTiersModal(item) {
			this.horse_selected = item
			if(this.all_tiers.length == 1) {
				this.tiers_selected = this.all_tiers[0]
				this.addHorseSire()
				return false
			}
			this.tiers_selected = null
			this.$refs.tiers.show()
		},
		
		async addHorseSire() {
			if(!this.tiers_selected) return false
			
			this.$refs.tiers.hide()
			this.processing = true
			const data = await this.addHorse(this.horse_selected.references.idPub, 'id_pub', this.tiers_selected.tiers_id)
			if(data.horse_id) {
				this.next(data.horse_id)
			}
		},
		
		async next(horse_id) {
			await this.duplicateHorseLicence(horse_id)
			// Retour vers ContractNew avec étalon + jument pré-remplis si on vient du formulaire de contrat
			if(this.$route.query.from === 'contract') {
				const params = { mare_id: horse_id }
				if(this.$route.query.stallion_id) params.stallion_id = this.$route.query.stallion_id
				this.$router.push({ name: 'ContractNew', params })
			} else {
				this.$router.push({ name: 'horseFiche', params: { horse_id }})
			}
		},
		
		openManuelCreation() {
			this.$router.push({name: 'horseCreation', query: {...this.$route.query, horse_nom: this.search_value}})
		},
		
		clean_input: function(input) {
			if(!input) return input
			input = input.toUpperCase()
			input = input.replace(/[\u2018\u2019]/g, "'")
			input = input.replace(new RegExp(/[èéêë]/g),"e")
			return input
		},
		
		saveFilters() {
			this.filters_saved = _deepClone(this.filters_ifce)
			this.$refs.filters.hide()
			this.search()
		},
		
		deleteFilter(index) {
			this.filters_saved[index] = null
			this.filters_ifce[index] = null
		},
		
		is_not_empty(filter) {
			return filter === true || typeof filter === 'number' || !_isEmpty(filter)
		},
		
		async showLicenceHorse() {
			this.show_licence_horses = true
			this.licence_horses_load = true
			
			let licence_horses = await this.getUserHorses()
			const clientarea_horses = await this.getHorses()
			const clientarea_ids = clientarea_horses.map(horse => horse.horse_sire || horse.horse_nom)
			
			licence_horses = licence_horses.filter(horse => !clientarea_ids.includes(horse.horse_sire))
			this.licence_horses = licence_horses.map(h => {
				let year = ''
				if(h.dateNaissance) {
					const naissance = new Date(h.dateNaissance)
					year = naissance.getFullYear()
				}
				return {
					horse_id: h.horse_id, 
					horse_nom: h.horse_nom, 
					horse_pere: h.pedigree.pere, 
					horse_mere: h.pedigree.mere, 
					horse_race: h.race_label, 
					horse_robe: h.robe_label, 
					horse_sexe: h.sexe_label, 
					horse_date: h.horse_datenaissance, 
					horse_sire: h.horse_sire, 
					horse_cle: h.horse_cle, 
					horse_wholesire: h.horse_sire+h.horse_cle,
					horse_year: year
				}
			})
			
			this.licence_horses_load = false
		},
		
		async addHorseLicence(item) {
			this.processing = true
			const data = await this.addHorse(item.horse_wholesire, 'sire')
			if(data.new) {
				this.next(data.horse_id)
			}
			else {
				this.infoToast("toast.horse_already_exists")
				this.$router.push({ name: 'HorseFicheInfo', params: {horse_id: data.horse_id} })
			}
		}
	},
	
	computed: {
		isMareContext() {
			return this.$route.query.from === 'mare' || this.$route.query.from === 'contract'
		},
		hasTooManyResults() {
			return this.raw_result_count >= 20
		},
		pageTitle() {
			return this.isMareContext
			? this.$t('horse.ajout_jument')
			: this.$t('horse.ajout_cheval')
		},
		searchTextKey() {
			return this.isMareContext
			? 'horse.text_rechercher_jument'
			: 'horse.text_rechercher_cheval'
		},
		error_message_trad() {
			if(['IK','IF','NOR'].indexOf(this.code_erreur) > -1) {
				return this.getTrad("horse.introuvable")
			}
			return this.getTrad("error."+(this.code_erreur == "" ? "UKE" : this.code_erreur))
		},
		race_formatted() {
			return this.filters_saved.race.map(race => race.race_label).join(' / ')
		}
	},
	
	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	}
}

</script>